import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useBranding } from '@/lib/branding/BrandingProvider';
import type { SessionDayBucket } from '@/lib/dashboard/useDashboardAnalytics';

export function SessionsChart({ data }: { data: SessionDayBucket[] }) {
  const { palette } = useBranding();
  const { electric, plasma } = palette;

  return (
    <div className="glass-card flex h-[340px] flex-col p-5">
      <p className="mb-4 text-xs font-medium uppercase tracking-wider text-muted-foreground">
        Sessions over time
      </p>
      <div className="min-h-0 flex-1">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barGap={2}>
            <CartesianGrid vertical={false} stroke="rgba(255,255,255,0.05)" />
            <XAxis
              dataKey="date"
              tick={{ fill: '#8B8FA3', fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              interval="preserveStartEnd"
            />
            <YAxis
              tick={{ fill: '#8B8FA3', fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              width={28}
              allowDecimals={false}
              className="hidden sm:block"
            />
            <Tooltip
              cursor={{ fill: 'rgba(255,255,255,0.03)' }}
              content={<CustomTooltip />}
              wrapperStyle={{ zIndex: 50 }}
            />
            <Bar
              dataKey="interviews"
              name="Interviews"
              fill={electric}
              radius={[4, 4, 0, 0]}
              stackId="sessions"
            />
            <Bar
              dataKey="assessments"
              name="Assessments"
              fill={plasma}
              radius={[4, 4, 0, 0]}
              stackId="sessions"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function CustomTooltip({
  active,
  payload,
  label,
}: {
  active?: boolean;
  payload?: { name: string; value: number; color: string }[];
  label?: string;
}) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-xl border border-white/10 bg-[#11132B] px-3 py-2 shadow-xl">
      <p className="mb-1 text-xs font-medium text-muted-foreground">{label}</p>
      {payload.map((entry) => (
        <div key={entry.name} className="flex items-center gap-2 text-xs text-white">
          <span className="h-2 w-2 rounded-full" style={{ backgroundColor: entry.color }} />
          <span>{entry.name}</span>
          <span className="ml-auto font-semibold">{entry.value}</span>
        </div>
      ))}
    </div>
  );
}
